import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Form, Button, Modal, Image } from "react-bootstrap";
import { TextField } from "@material-ui/core";
//import { sendSmsAdmin } from "../../../../store/actions/AdminSms&Notification/message_notification";
import { send_sms_diner } from "../../../store/actions/notificationAction/notificationActions";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { amApi } from "../../../api/apiHelper";

const DeliveryPerson = forwardRef(({ edit, hide, ...props }, ref) => {
  const [showSMS, seShowSMS] = useState(false);
  const handleCloseSMS = () => {
    seShowSMS(false);
  };
  const handleShowSMS = () => seShowSMS(true);

  useImperativeHandle(ref, () => ({
    handleShow() {
      handleShowSMS();
    },
  }));

  const formik = useFormik({
    initialValues: {
      name: "",
      phoneNumber: "",
      link: "",
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(256, "Must be 256 characters or less")
        .required("Please enter Message"),
      phoneNumber: yup
        .string()
        .max(10, "Must be a valid Number")
        .required("Please enter Message"),
      link: yup.string().url("Must be valid URL"),
    }),
    onSubmit: async (values) => {
      const onErrorSms = () => {
        handleCloseSMS();
        formik.resetForm();
      };

      const onSuccessSms = () => {
        handleCloseSMS();
        formik.resetForm();
      };

      if (props.id) {
        let deliveryObj = {
          name: values.name,
          link: values.link,
          phoneNumber: values.phoneNumber,
        };
        try {
          let resp = await amApi.patch(`ordering/${props.id}`, {
            deliveryPerson: deliveryObj,
            order_status: 4,
            id: props?._id,
          });
          onSuccessSms();
        } catch (err) {
          console.log(err);
          onErrorSms();
        }
        //   let formData = {};
        //   // if (props.mobile_number.startsWith("+91")) {
        //   //   formData.mobile_number = "+91" + props.mobile_number.substring(3);
        //   // } else {
        //   //   formData.mobile_number = "+91" + props.mobile_number;
        //   // }
        //   formData.message = values.message;
        //   formData.order_id = props.order_id;
        //   formData.type = props.type || 3;
        //   formData.sms = true;
        //   formData.id = props.id;

        //   const token = props.auth.user.accessToken;
        //   props.send_sms_diner(formData, token, onSuccessSms, onErrorrSms);
      }
    },
  });

  return (
    <React.Fragment>
      {!hide ? (
        <Button
          variant="link"
          className="enIconBtn mr-3"
          onClick={handleShowSMS}
        >
          {!edit ? (
            <Image
              src={require("../../../assets/images/UserManagement/plusRound.svg")}
              alt="Delivery"
              title="Delivery Details"
              fluid
            />
          ) : (
            <Image
              src={require("../../../assets/images/UserManagement/pencil.svg")}
              alt="Delivery"
              title="Delivery Details"
              fluid
            />
          )}
        </Button>
      ) : null}
      <Modal
        show={showSMS}
        dialogClassName="model-z-index-1061"
        className="z-index-1060"
        onHide={handleCloseSMS}
        centered
      >
        <Modal.Header className="py-0 pt-3 border-0" closeButton>
          <Modal.Title className="f24-700">Delivery Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={formik.handleSubmit}>
            <TextField
              id="outlined-basic"
              label="Name"
              variant="outlined"
              className="m-2 w-100"
              name="name"
              onChange={formik.handleChange}
              value={formik.values.name}
              onBlur={formik.handleBlur}
              //onInvalid={formik.errors.email && formik.touched.email}
              isInvalid={formik.errors.name && formik.touched.name}
            />
            {formik.errors.name && formik.touched.name ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.name}
              </div>
            ) : null}
            <TextField
              id="outlined-basic"
              label="Phone Number"
              variant="outlined"
              className="m-2 w-100"
              name="phoneNumber"
              onChange={formik.handleChange}
              value={formik.values.phoneNumber}
              onBlur={formik.handleBlur}
              //onInvalid={formik.errors.email && formik.touched.email}
              isInvalid={
                formik.errors.phoneNumber && formik.touched.phoneNumber
              }
            />
            {formik.errors.phoneNumber && formik.touched.phoneNumber ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.phoneNumber}
              </div>
            ) : null}
            <TextField
              id="outlined-basic"
              label="Tracking URL"
              variant="outlined"
              className="m-2 w-100"
              name="link"
              onChange={formik.handleChange}
              value={formik.values.link}
              onBlur={formik.handleBlur}
              //onInvalid={formik.errors.email && formik.touched.email}
              isInvalid={formik.errors.link && formik.touched.link}
            />
            {formik.errors.link && formik.touched.link ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.link}
              </div>
            ) : null}
            <div className="d-flex align-items-center pt-4">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5"
                onClick={() => {
                  if (props?.onClose) {
                    props.onClose();
                  }
                  handleCloseSMS();
                }}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5"
                type="submit"
                //onClick={handleCloseSMS}
              >
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
});

export default DeliveryPerson;
